export enum IReelActionButtonType {
    CustomUrl = 1,
    InquiryForm = 2
}
export enum IReelActionButtonType {
    CustomUrl = 1,
    InquiryForm = 2
}
